module.exports = __webpack_public_path__ + "static/media/good_v_bad_feedback.d4733de0.webp";